


























import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class CalcCardPrice extends Vue {
    @Prop({ default: "sm" }) view: "sm" | "md" | "lg";
    @Prop({ default: null }) price: number;
    @Prop({ default: null }) newPrice: number;
    @Prop(Boolean) final: boolean;
    get br() {
        return {
            sm: this.view == "sm",
            md: this.view == "md",
            lg: this.view == "lg"
        };
    }

    get containerStyles() {
        if (this.br.sm) return "min-width: 100px;";
        if (this.br.lg)
            return "margin-right: 8px; flex: auto;display:flex;align-items:center";
        return "";
    }
    get titleText() {
        const state = this.final ? 'Финальная' : 'Предварительная';
        return `${state} стоимость`
    }
    get titleStyles() {
        let styles = "color: #7d8d93;";
        let appends = {
            sm: "margin-right: 8px; font-size: 12px;",
            md: `margin-right: 8px; font-size: ${this.final ? "12" : "14"}px`,
            lg: "font-size: 14px;margin-right: 8px"
        };
        styles += appends[this.view];
        return styles;
    }
    get priceStyles() {
        let styles = "font-weight: bold;font-size:";
        if (this.br.sm) return (styles += "16px;");
        else if (this.br.lg && this.newPrice)
            return (styles += "24px;line-height: 1;margin-top: 6px;");
        else return (styles += "18px;"); // md and lg
    }
}
